import { Payments } from "@/constants";
import { AlipayForm } from "./alipay";
import { BankForm } from "./bank";
import { WechatForm } from "./wechat";
import { USDTForm } from "./usdt";
import { DigitalRMBForm } from "./rmb";
export type FormContentProps = {
  onUpload(file: File | Blob, decodeQRcode?: string): Promise<string>;
  onDelete?(): void;
  flushCodeImage(): void;
  codeImage: string;
};
export const FormMap: Record<string, (props: FormContentProps) => JSX.Element> =
  {
    [Payments.ALI]: AlipayForm,
    [Payments.WE_CHAT]: WechatForm,
    [Payments.BANK]: BankForm,
    [Payments.CRYPTO_COIN]: USDTForm,
    [Payments.DIGITAL_RMB]: DigitalRMBForm,
  };
